export default "__VITE_ASSET__d1479206__"